import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Page, Wrapper, Paper, Button, Toolbar, AlertConfirm, Table, Row, Cell, Tag, Modal, LinkProduct, Currency } from './../../../components/ui';
import { TreatmentGroupService, ProductService } from './../../../services';
import { isUndefined, isStatus, isStatusColor, isBinary, isBinaryColor, hasPermission, findPermissionProps } from './../../../utilities/utils';

import API from './../../../config/api';
import TEXT from './../../../config/text';

class Page__TreatmentGroupList extends React.Component {

    constructor(props){
      super(props);
      this.state = {
        permission: null,
        name: '...',
        loading: false,
        page: 0,
        total: 0,
        id: null,
        entities: [],
        remove: false,
        productsModalShow: false,
        selectedGroup: null,
        groupProducts: [],
        groupProductsLoading: false,
        thead: [
          { id: 'name', name: this.props.t('field.name') },
          { id: 'enabled', name: this.props.t('field.status') },
          { id: 'products', name: 'Productos', align: 'center' },
          { id: 'actions', name: this.props.t('field.actions'), align: 'right' }
        ]
      };
    };

    componentDidMount(){
      this._Init();
    };

    componentDidUpdate(prev_props){
      if(this.props.match.params.page !== prev_props.match.params.page){
        this._All(this.props.match.params.page || 0);
      }
    };

    _Init = () => {
      this.setState({ permission: findPermissionProps(this.props.session, API.permissions.treatment_groups, this.props.t('page.treatment_groups.name')) });

      const page = this.props.match.params.page || 0;

      if(!isUndefined(page)){
        if(!isNaN(page) && page >= 0){
          this._All(page);
        }else{
          this.props.history.push('/treatment-groups');
        }
      }else{
        this._All(this.state.page);
      }
    };

    _All = (page) => {
      this.setState({ loading: false, entities: [] });

      TreatmentGroupService.list(page).then((response) => {
        this.setState({
          loading: true,
          page: !isUndefined(page) ? parseInt(page,10) : 0,
          entities: response.treatmentGroups,
          total: response.total
        });
      }).catch(() => {
        this.props.alertShow({ open: true, severity: 'error', message: TEXT.message.error });
      });
    };

    _Remove = (id) => {
      TreatmentGroupService.remove(id).then(() => {
        this.setState({ remove: false });
        this._Init();
        this.props.alertShow({ open: true, severity: 'success', message: TEXT.message.success });
      }).catch((error) => {
        this.setState({ remove: false });
        this.props.alertShow({ open: true, severity: 'error', message: error.data ? error.data.message : TEXT.message.error });
      });
    };

    handleRemove = (id) => {
      this.setState({ id: id, remove: true });
    }

    handleConfirmRemoveConfirm = () => {
      this._Remove(this.state.id);
    };

    handleConfirmRemoveCancel = () => {
      this.setState({ remove: false });
    };

    handleProductsModalOpen = (group) => {
      this.setState({ productsModalShow: true, selectedGroup: group, groupProductsLoading: true, groupProducts: [] });

      ProductService.list(0, { treatmentGroup: group._id, items: 100 }).then((response) => {
        this.setState({
          groupProductsLoading: false,
          groupProducts: response.products || []
        });
      }).catch(() => {
        this.setState({ groupProductsLoading: false });
        this.props.alertShow({ open: true, severity: 'error', message: TEXT.message.error });
      });
    };

    handleProductsModalClose = () => {
      this.setState({ productsModalShow: false, selectedGroup: null, groupProducts: [], groupProductsLoading: false });
    };

    handleUnlinkProduct = (product) => {
      ProductService.update(product._id, { name: product.name, treatmentGroup: '' }).then(() => {
        this.setState((prevState) => ({
          groupProducts: prevState.groupProducts.filter((p) => p._id !== product._id)
        }));
        this.props.alertShow({ open: true, severity: 'success', message: TEXT.message.success });
      }).catch((error) => {
        this.props.alertShow({ open: true, severity: 'error', message: error.data ? error.data.message : TEXT.message.error });
      });
    };

    handleChangePage = (event, page) => {
      this.setState({ page: page, loading: false });
      this.props.history.push(`/treatment-groups/page/${ page }`);
    };

    handleToggleTreatmentGroupProp = ({ _id, name }, newValues) => {
      this.setState({ loading: false });

      TreatmentGroupService.update(_id, { ...newValues, name }).then(() => {
        this.props.alertShow({ open: true, severity: 'success', message: TEXT.message.success });

        const nextEntities = this.state.entities.map(entity => {
          if (entity._id === _id) {
            return {
              ...entity,
              ...newValues
            };
          } else {
            return entity;
          }
        });

        this.setState({
          entities: nextEntities,
          loading: true
        });

      }).catch((error) => {
        this.setState({ loading: true });
        this.props.alertShow({ open: true, severity: 'error', message: error.data ? error.data.message : TEXT.message.error });
      });
    };

    render(){
      const { session } = this.props;
      const { permission, name, loading, entities, thead, total, page, remove, productsModalShow, selectedGroup, groupProducts, groupProductsLoading } = this.state;

      return(
        <Page>
          <Wrapper>
            <Toolbar title={permission ? permission.name : name} dividerMobile>
              { hasPermission(session.user.permissions, API.permissions.treatment_groups_management, session.user) && (
                <Button component={ NavLink } to="/treatment-groups/create" icon="add" size="medium">
                  {this.props.t('button.create')}
                </Button>
              )}
            </Toolbar>

            <Paper disablePadding>
              <AlertConfirm
                 status={ remove }
                 message={this.props.t('messages.treatment_group_delete_confirm')}
                 cancel={ () => { this.handleConfirmRemoveCancel() } }
                 confirm={ () => { this.handleConfirmRemoveConfirm() } }
              />

              <Modal
                title={ selectedGroup ? `Productos - ${selectedGroup.name}` : 'Productos' }
                status={ productsModalShow }
                handleCancel={ () => this.handleProductsModalClose() }
                maxWidth="md"
              >
                <Table
                  thead={ [
                    { id: 'name', name: this.props.t('field.name') },
                    { id: 'price', name: 'Precio' },
                    { id: 'enabled', name: 'Estado' },
                    { id: 'public', name: 'Público' },
                    { id: 'category', name: 'Categoría' },
                    { id: 'actions', name: this.props.t('field.actions'), align: 'right' }
                  ] }
                  loading={ !groupProductsLoading }
                  total={ groupProducts.length }
                  page={ 0 }
                  onChangePage={ () => {} }
                >
                  { groupProducts.length > 0 && groupProducts.map(product => (
                    <Row key={ product._id }>
                      <Cell>
                        <LinkProduct product={ product } />
                      </Cell>
                      <Cell>
                        <Currency value={ product.price } />
                      </Cell>
                      <Cell>
                        <Tag text={ isStatus(product.enabled) } color={ isStatusColor(product.enabled) } />
                      </Cell>
                      <Cell>
                        <Tag text={ isBinary(product.public) } color={ isBinaryColor(product.public) } />
                      </Cell>
                      <Cell>
                        { product.categories && product.categories.length > 0 ? product.categories[0].name : '-' }
                      </Cell>
                      <Cell align="right">
                        { hasPermission(session.user.permissions, API.permissions.products_management) && (
                          <Button size="small" icon="delete" color="danger" onClick={ () => this.handleUnlinkProduct(product) } />
                        )}
                      </Cell>
                    </Row>
                  ))}
                  { (groupProductsLoading === false && groupProducts.length === 0) && (
                    <Row>
                      <Cell colSpan={ 6 } align="center">
                        { TEXT.message.without_results }
                      </Cell>
                    </Row>
                  )}
                </Table>
              </Modal>

              <Table thead={ thead } loading={ loading } total={ total } page={ page } onChangePage={ this.handleChangePage }>
                { entities.length > 0 && entities.map(entity => (
                  <Row key={ entity._id }>
                    <Cell>{ entity.name }</Cell>
                    <Cell>
                      { hasPermission(session.user.permissions, API.permissions.treatment_groups_management) ?
                        <div
                          onClick={() => this.handleToggleTreatmentGroupProp(entity, { enabled: !(entity.enabled) })}
                          style={{ cursor: 'pointer' }}
                        >
                          <Tag text={ isStatus(entity.enabled) } color={ isStatusColor(entity.enabled) }/>
                        </div>
                        :
                        <Tag text={ isStatus(entity.enabled) } color={ isStatusColor(entity.enabled) }/>
                      }
                    </Cell>
                    <Cell align="center">
                      <div onClick={ () => this.handleProductsModalOpen(entity) } style={{ cursor: 'pointer', display: 'inline-block' }}>
                        <Tag text="Ver listado" />
                      </div>
                    </Cell>
                    <Cell align="right">
                      <Button component={ NavLink } to={`/treatment-groups/edit/${ entity._id }`} size="small" icon="edit" />
                      { hasPermission(session.user.permissions, API.permissions.treatment_groups_management, session.user) && (
                        <Button size="small" icon="delete" color="danger" onClick={() => this.handleRemove(entity._id)} />
                      )}
                    </Cell>
                  </Row>
                ))}
              </Table>
            </Paper>
          </Wrapper>
        </Page>
      )
    }
};

const mapStateToProps = (state) => {
  return { session: state.userState }
};

const mapDispatchToProps = (dispatch) => {
  return {
    alertShow: (data) => {
      dispatch({ type: 'ALERT_SHOW', data: data });
    }
  }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Page__TreatmentGroupList));
